// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"795e4260dbc8346a7ab8","691":"4b895aafe81ffbbe1f99"}[chunkId] + ".js";
};